import { defineMessages } from 'react-intl';

export default defineMessages({
  ruleEditorHeader: {
    description: 'Automation Rules editor header',
    defaultMessage: 'Define Rule',
    id: 'dy1kMK',
  },
  ruleEditorCancel: {
    description: 'Automation Rules editor Cancel button',
    defaultMessage: 'Cancel',
    id: '7+oKbu',
  },
  ruleEditorName: {
    description: 'Automation Rules editor Rule Name / Summary label',
    defaultMessage: 'Summary',
    id: 'UUq9lD',
  },
  ruleActiveCheckbox: {
    description: 'Automation Rules editor Rule Active true/false',
    defaultMessage: 'Active Rule',
    id: 'ZILUv8',
  },
  ruleCriteriaTypeEveryOrder: {
    description: 'Automation Rules editor Rule Criteria Every Order',
    defaultMessage: '<b>EVERY</b> order as it is imported',
    id: 'Y6CQLk',
  },
  ruleCriteriaTypeEveryOrderOption: {
    description: 'Automation Rules editor Rule Criteria Every Order dropdown option (plain text)',
    defaultMessage: 'Every order as it is imported',
    id: 'euIvW7',
  },
  ruleCriteriaIfBadge: {
    description: 'Badge label for the IF criteria selector in the automation rule editor',
    defaultMessage: 'If',
    id: 'lMxGFa',
  },
  ruleCriteriaTypeSpecificCriteria: {
    description: 'Automation Rules editor Rule Criteria Specific criteria',
    defaultMessage: 'Orders match these specific criteria',
    id: 'SO8w1y',
  },
  ruleCriteriaTypeExistingFilter: {
    description: 'Automation Rules editor Rule Criteria Existing Filter',
    defaultMessage: 'Orders match an existing filter',
    id: '4fAYkS',
  },
  ruleCriteriaSelectFilter: {
    description: 'Automation Rules editor Rule Criteria Select a Filter',
    defaultMessage: 'Select filter...',
    id: '6exPrz',
  },
  ruleEditorSave: {
    description: 'Automation Rules editor Save button',
    defaultMessage: 'Save Rule',
    id: 'YwKK6E',
  },
  ruleEditorStatus: {
    description: 'Automation Rules editor Status field',
    defaultMessage: 'Status',
    id: 'Q6YwAK',
  },
  createAction: {
    description: 'Automation Rules editor Add Action button',
    defaultMessage: 'Add an Action',
    id: 'EhWYsW',
  },
  ruleDeleteLink: {
    description: 'Automation Rules editor Delete Rule button',
    defaultMessage: 'Delete Rule',
    id: 'OkOtty',
  },
  errorOccurredMessage: {
    description: 'Automation Rules editor error indicator',
    defaultMessage:
      'There are required fields or actions that need to be completed before saving. Please fill out the required field or action type.',
    id: 'hcAvTB',
  },
  ruleTypeHeader: {
    description: 'Automation Rules editor - rule type header',
    defaultMessage: 'If orders match the following criteria',
    id: '3yW+g4',
  },
  automationRulesConfirmCancelBody: {
    description: 'Body text to exit Automation rules creation',
    defaultMessage: 'If you close this window, all unsaved data will be lost. Are you sure you want to exit?',
    id: 'iGJ+Re',
  },
  automationRulesConfirmCancelButton: {
    description: 'Button text to exit Automation rules creation',
    defaultMessage: 'OK',
    id: 'ZAd3vt',
  },
  automationRulesConfirmCancelHeader: {
    description: 'Header text to exit Automation rules creation',
    defaultMessage: 'Confirmation',
    id: 'ERZpxN',
  },
  ruleActiveDisabledTooltip: {
    description: 'Tooltip for disabled active checkbox',
    defaultMessage: 'This rule contains actions that you do not have access to',
    id: '9fvmbV',
  },
  ruleHasLimitedAccess: {
    defaultMessage:
      'This rule contains actions that are not supported with your current subscription to reactivate the rule please remove unsupported actions below',
    description: 'Informs user that it has types not supported anymore',
    id: '1o3PmN',
  },
  ruleHasLimitedAccessTitle: {
    defaultMessage: 'Rule not supported',
    description: "Title shown when a feature is not available on the user's plan",
    id: 'N4gjR8',
  },
  aiGeneratedRuleBanner: {
    defaultMessage: 'This rule was AI generated, review before applying.',
    description: 'Banner message shown for AI-generated automation rules',
    id: '4NHlsA',
  },
  closeDrawerAriaLabel: {
    defaultMessage: 'Close rule editor',
    description: 'ARIA label for the close button in the rule editor drawer',
    id: 'wuIkvg',
  },
  flowWhenBadge: {
    defaultMessage: 'When',
    id: 'hQVujB',
    description: 'Badge label for the trigger step in the automation rule flow diagram',
  },
  flowOrderImported: {
    defaultMessage: 'Order imported',
    id: 'Q94FQX',
    description: 'Label for the order imported trigger step in the automation rule flow diagram',
  },
  flowAutomationComplete: {
    defaultMessage: 'Automation Complete',
    id: 'JBMAZ+',
    description: 'Label for the final step in the automation rule flow diagram',
  },
});
